import React, { useState, useEffect } from "react";

import { X } from "lucide-react";

const SmartAppBanner = () => {
  const [isVisible, setIsVisible] = useState(false);
  const [platform, setPlatform] = useState(null);

  // App store configuration
  const appConfig = {
    ios: {
      appId: "id6751130474",
      appName: "Lunova Player",
      appIcon: "/logo.png",
      storeUrl: "https://apps.apple.com/us/app/lunovaapp/id6751130474",
    },
    android: {
      packageName: "app.lunova.player",
      appName: "Lunova Player",
      appIcon: "/logo.png",
      storeUrl:
        "https://play.google.com/store/apps/details?id=app.lunova.player&pli=1",
    },
  };

  useEffect(() => {
    // Check if banner was dismissed
    const dismissed = localStorage.getItem("smartAppBannerDismissed");
    const dismissedTime = dismissed ? parseInt(dismissed, 10) : 0;
    const daysSinceDismissed =
      (Date.now() - dismissedTime) / (1000 * 60 * 60 * 24);

    // Show again after 7 days
    if (dismissed && daysSinceDismissed < 7) {
      return;
    }

    // Detect platform
    const userAgent = navigator.userAgent || navigator.vendor || window.opera;

    if (/android/i.test(userAgent)) {
      setPlatform("android");
      setIsVisible(true);
    } else if (/iPad|iPhone|iPod/.test(userAgent) && !window.MSStream) {
      setPlatform("ios");
      setIsVisible(true);
    }
  }, []);

  const handleDismiss = () => {
    localStorage.setItem("smartAppBannerDismissed", Date.now().toString());
    setIsVisible(false);
  };

  const handleOpenApp = () => {
    const config = appConfig[platform];

    if (platform === "ios") {
      // Try to open the app first, then fall back to App Store
      window.location.href = `lunova://`;
      setTimeout(() => {
        window.location.href = config.storeUrl;
      }, 500);
    } else if (platform === "android") {
      // Intent URL tries app first, falls back to Play Store automatically
      window.location.href = `intent://open#Intent;scheme=lunova;package=${config.packageName};S.browser_fallback_url=${encodeURIComponent(config.storeUrl)};end`;
    }
  };

  if (!isVisible || !platform) {
    return null;
  }

  const config = appConfig[platform];

  return (
    <div
      className="fixed top-0 left-0 right-0 z-[100000] bg-gray-900/95 backdrop-blur-sm border-b border-gray-700"
      style={{
        paddingTop: "env(safe-area-inset-top, 0px)",
      }}
    >
      <div className="flex items-center gap-3 px-4 py-3">
        {/* Close Button */}
        <button
          className="flex-shrink-0 text-gray-400 hover:text-white transition-colors p-1"
          onClick={handleDismiss}
        >
          <X className="w-5 h-5" />
        </button>

        {/* App Icon */}
        <div className="flex-shrink-0 w-12 h-12 rounded-xl overflow-hidden bg-gray-800 shadow-lg">
          <img
            alt={config.appName}
            className="w-full h-full object-cover"
            src={config.appIcon}
            onError={(e) => {
              e.target.style.display = "none";
            }}
          />
        </div>

        {/* App Info */}
        <div className="flex-1 min-w-0">
          <h3 className="text-white font-semibold text-sm truncate">
            {config.appName}
          </h3>
          <p className="text-gray-400 text-xs">
            {platform === "ios" ? "On the App Store" : "On Google Play"}
          </p>
          <div className="flex items-center gap-1 mt-0.5">
            {[1, 2, 3, 4, 5].map((star) => (
              <svg
                className="w-3 h-3 text-yellow-400"
                fill="currentColor"
                key={star}
                viewBox="0 0 20 20"
              >
                <path d="M9.049 2.927c.3-.921 1.603-.921 1.902 0l1.07 3.292a1 1 0 00.95.69h3.462c.969 0 1.371 1.24.588 1.81l-2.8 2.034a1 1 0 00-.364 1.118l1.07 3.292c.3.921-.755 1.688-1.54 1.118l-2.8-2.034a1 1 0 00-1.175 0l-2.8 2.034c-.784.57-1.838-.197-1.539-1.118l1.07-3.292a1 1 0 00-.364-1.118L2.98 8.72c-.783-.57-.38-1.81.588-1.81h3.461a1 1 0 00.951-.69l1.07-3.292z" />
              </svg>
            ))}
            <span className="text-gray-500 text-xs ml-1">FREE</span>
          </div>
        </div>

        {/* Open/Get Button */}
        <button
          className="flex-shrink-0 bg-blue-500 hover:bg-blue-600 text-white font-semibold text-sm px-5 py-2 rounded-full transition-colors"
          onClick={handleOpenApp}
        >
          {platform === "ios" ? "GET" : "OPEN"}
        </button>
      </div>
    </div>
  );
};

export default SmartAppBanner;
